import { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';

import { Spinner } from '@climatepartner/components';
import { client } from '@climatepartner/ecopilot-sdk';

import useAuth from '../hooks/useAuth';

export const EcopilotApiClientSetup: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { user } = useAuth();
    const { showBoundary } = useErrorBoundary();

    useEffect(() => {
        if (user) {
            client.setConfig({
                baseURL: import.meta.env.VITE_ECOPILOT_API_BASE_URL,
            });
            const interceptor = client.instance.interceptors.request.use(async (request) => {
                request.headers.setAuthorization(`Bearer ${await user.accessToken().catch(showBoundary)}`);
                return request;
            });

            return () => {
                client.instance.interceptors.request.eject(interceptor);
            };
        }
    }, [user, showBoundary]);

    if (!user) {
        return <Spinner isFixed />;
    }

    return children;
};
